import BackgroundCheckGeneralAlert from './BackgroundCheckGeneralAlert';
export default BackgroundCheckGeneralAlert;
